import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'qaroni-title-dashboard',
  templateUrl: './title-dashboard.component.html',
  styleUrls: ['./title-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TitleDashboardComponent {}
